import angular from 'angular';

import RcuQueueOptionsConstant from './RcuQueueOptionsConstant';
import RcuManagementService from './RcuManagementService';
import RcuQueueClearModal from './RcuQueueClearModal';
import RcuManagementComponent from './RcuManagementComponent';

export default angular
  .module('petroCloud.admin.rcuManagement', [])
  .constant('RcuQueueOptions', RcuQueueOptionsConstant)
  .service('RcuManagementService', RcuManagementService)
  .controller('RcuQueueClearModalController', RcuQueueClearModal)
  .component(RcuManagementComponent.name, RcuManagementComponent)
  .name;
